import Col from './Col.template'

export default Col
